import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { loadInitialData } from '../effects/loadInitialData';
import { TBoardId } from '../../../../../../../../../types/types';

export const onDidMount = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(loadInitialData(boardId))
    };
    return action;
};
